import React from 'react';
import { KeepAlive } from 'react-activation';
import './HomePageSlide.css';
// import HomePageButtons from '../HomePageButtons';

const HomePageSlide1 = () => {
  return (
    <KeepAlive>
      <div className="HomePageSlide-wrapper">
        <h3 className="HomePageSlide-title">МЕТОД ЧУВАКА</h3>
        <p className="HomePageSlide-description HomePageSlide-description_wrapper">Удобный инструмент</p>
        <p className="HomePageSlide-description">для арбитража</p>
        <p className="HomePageSlide-description">криптовалют без карт</p>
        <div className="HomePageSlide-images_wrapper">
          <img className="HomePageSlide-image HomePageSlide-images_1" src="/images/screenshot1.png" alt="pic" />
          <img className="HomePageSlide-image HomePageSlide-images_2" src="/images/screenshot2.png" alt="pic" />
          <img className="HomePageSlide-image HomePageSlide-images_3" src="/images/screenshot3.png" alt="pic" />
        </div>
        <div className="HomePageSlide-image-chuvak_wrapper">
          <img className="HomePageSlide-images_chuvak" src="/images/chuvak.png" alt="pic" />
          <div className="HomePageSlide-images_shadow" />
        </div>

        <div className='HomePageSlide-info_wrapper'>
          <div className='HomePageSlide-info_marker'>
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
              <path d="M4.96191 6.39584L6.75432 4.60344L4.96191 2.81104" stroke="#fff" strokeWidth="0.716961" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M2.45312 6.39584L4.24553 4.60344L2.45312 2.81104" stroke="#fff" strokeWidth="0.716961" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <p className='HomePageSlide-info_text'>
            Легко находите прибыльные арбитражные сделки на ведущих криптобиржах с нашим простым и удобным скринером.
            {/* <br></br>(стратегии Spot-Futures и Futures-Futures). */}
          </p>
        </div>
        {/* <div className='HomePageSlide-info_wrapper'>
          <div className='HomePageSlide-info_marker'>
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
              <path d="M4.96191 6.39584L6.75432 4.60344L4.96191 2.81104" stroke="#fff" strokeWidth="0.716961" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M2.45312 6.39584L4.24553 4.60344L2.45312 2.81104" stroke="#fff" strokeWidth="0.716961" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <p className='HomePageSlide-info_text'>
            Получи уже сейчас бесплатное обучение
            <br></br>и 1 неделю подписки!
          </p>
        </div> */}
        {/* <HomePageButtons/> */}

        <div className="help-and-payment help-and-payment_home">
          <a href='https://metod-payscanner.ru/#oplata' target='_blank' rel='noreferrer' className="link-btn link-guide">Оплатить доступ</a>
        </div>
      </div>
    </KeepAlive>
  );
};

export default HomePageSlide1;
